// extracted by mini-css-extract-plugin
module.exports = {"title":"ClientTitle_title__oNInP","inverted":"ClientTitle_inverted__h_O68","vertical":"ClientTitle_vertical__coOG6","skipMargin":"ClientTitle_skipMargin__sIrSA"};